const API = {
  CMS: {
    // Auth
    POST_LOGIN: '/v1/user/auth/login',
    GET_SESSION: '/v1/user/profile',
    POST_VERIFY_PIN: '/v1/user/auth/verify-pin',

    // Other
    GET_PNP: '/v1/others/privacy-policy',
    GET_TNC: '/v1/others/terms-and-condition',

    // Sign Up
    POST_OTP_REQUEST: '/v1/user/auth/otp-request',
    POST_OTP_RESEND: '/v1/user/auth/otp-resend',
    POST_OTP_VERIFY: '/v1/user/auth/otp-verify',
    POST_REGISTER: '/v1/user/auth/register',
    POST_FORGOT_SET_PASSWORD: '/v1/user/auth/forgot/set-password',
    POST_FORGOT_SET_PIN: '/v1/user/auth/forgot/set-pin',
    POST_SET_PIN: '/v1/user/auth/set-pin',

    // Site
    GET_SITES: '/v1/site',
    GET_SITE: '/v1/site',

    // Charger
    POST_CHECK_CHARGER: '/v1/charger/qr-check',
    POST_CHARGER_RATES: '/v1/charger/rate-list',
    GET_CONNECTOR_TYPE_LIST: '/v1/charger/connector-type-list/dropdown',
    GET_CAPACITY_LIST: '/v1/charger/capacity-list/dropdown',

    // Checkout
    POST_PRE_CHECKOUT: '/v1/transaction/pre-checkout',
    POST_CHECKOUT: '/v1/transaction/checkout',
    GET_TRANSACTION: '/v1/transaction',
    POST_PRE_REMOTE_START_CHARGING: '/v1/transaction/pre-remote-start',
    POST_REMOTE_START_CHARGING: '/v1/transaction/remote-start',
    POST_REMOTE_STOP_CHARGING: '/v1/transaction/remote-stop',
    POST_CANCEL_TRANSACTION: '/v1/transaction/cancel',
    WEBSOCKET_CHARGING: '/ws/charge-connect',

    // Activity
    GET_ACTIVITY_LASTEST: '/v1/transaction/home-ongoing',
    GET_ACTIVITY_ONGOING: '/v1/transaction/activity-ongoing',
    GET_ACTIVITY_RECENT: '/v1/transaction/activity-history',
    GET_ACTIVITY_HISTORY: '/v1/transaction/activity-history',

    // Profile
    POST_CHECK_PASSWORD: '/v1/user/password-check',
    PUT_PASSWORD_CHANGE: '/v1/user/password-change',
    PUT_CHANGE_PIN: '/v1/user/change-pin',
    GET_PROFILE_USER: '/v1/user/profile',
    PUT_PROFILE_USER: '/v1/user',
    PUT_PROFILE_USER_EMAIL: '/v1/user/email-change',
    PUT_PROFILE_USER_PHONE: '/v1/user/phone-change-number',
    GET_LIST_HELP: '/v1/others/help',

    // License Plate
    GET_LICENSE_PLATE_LIST: '/v1/user/dropdown/license-plate',
    POST_LICENSE_PLATE: '/v1/user/license-plate',
    DELETE_LICENSE_PLATE: (licenseId: number) =>
      `/v1/user/license-plate/${licenseId}`,
    PUT_LICENSE_PLATE: (licenseId: number) =>
      `/v1/user/license-plate/${licenseId}`,

    HOME: {
      GET_POINT_BALANCE: '/v1/pointBalance',
      GET_HISTORY_BALANCE: '/v1/pointBalance/history'
    },

    TOP_UP: {
      GET_DROPDOWN_PAYMENT_METHOD: '/v1/transaction/payment-method/dropdown'
    },

    CHARGING: {
      POST_CALULATE_RATE: '/v1/charger/tariff-calculation',
      GET_DETAIL: (uuid: string) => `/v1/transaction/${uuid}`
    },

    SYSTEM_STATUS: {
      GET_SYSTEM_STATUS: '/v1/others/system-status'
    }
  }
}

export default API
